'use strict';

/*global services*/
/*global jcsBarcode*/
/*global jcsNumber*/
/*global initialize*/
/*global createObjectCallBack*/

function JobCardSearchService() {
  this.modal = null;

  this.init();
}

JobCardSearchService.prototype = $.extend({}, {
  constructor: 'JobCardSearchService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('shown.bs.tab', '.job-card-search__tabs', function (e) {
      _this.changeTab(e);
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  changeTab: function changeTab(event) {
    var _this = this;

    var $tab = $(event.target);

    _this.modal.contentDOM().find('[name$="[SearchBy]"]').val($tab.data('search_by'));
    _this.focusInput();

    return _this;
  },

  focusInput: function focusInput() {
    var _this = this;

    var $form = _this.modal.contentDOM().find('form');
    var searchBy = parseInt($form.find('[name$="[SearchBy]"]').val());
    var $input = null;
    if (searchBy === jcsNumber) {
      $input = $form.find('[name$="[Number]"]');
    } else {
      $input = $form.find('[name$="[Barcode]"]');
    }

    setTimeout(function () {
      $input.focus();
    }, 300);

    return _this;
  },

  initForm: function initForm(data) {
    var _this = this;

    _this.modal.content(data.html);
    initialize(_this.modal.contentDOM());

    _this.focusInput();

    return _this;
  },

  submitForm: function submitForm(callback) {
    var _this = this;

    var $form = _this.modal.contentDOM().find('form');

    _this.modal.block();
    $.post(services.get('router').path('job_card_search'), $form.serialize(), function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.modal.close(function () {
          callback(res.data);
        });
      } else if (res.msg === 'NOT_VALID') {
        _this.initForm(res.data);
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  search: function search(params, callback) {
    var _this = this;

    if (!('searchBy' in params)) {
      params.searchBy = jcsBarcode;
    }

    _this.modal.open({
      title: params.title,
      saveBtnTitle: services.get('translator').trans('form.do_search'),
      height: 'auto',
      width: 'md',
      submitCallBack: createObjectCallBack(_this, 'submitForm', callback),
      enterSubmitCallBack: createObjectCallBack(_this, 'submitForm', callback),
      form: true,
      keyboardClose: false,
      focusInput: false
    });

    _this.modal.block();
    $.get(services.get('router').path('job_card_search'), { SearchBy: params.searchBy }, function (res) {
      _this.modal.unBlock();
      if (res.msg === 'SUCCESS') {
        _this.initForm(res.data);
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = services.get('modal-job-card');

    _this.registerCallbacks();

    return _this;
  }
});
